import app from '../app';
import avatar from '../../common/helpers/avatar';
import Button from '../../common/components/Button';
import username from '../../common/helpers/username';
import nickname from '../../common/helpers/nickname';
import Stream from '../../common/utils/Stream';
import Placeholder from '../../common/components/Placeholder';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import Page, { IPageAttrs } from '../../common/components/Page';
import signName from '../dianLiang/signName';
import AlertUtil from '../dianLiang/alertUtil';

export default class ProfilePagePhone extends Page {
  oninit(vdom) {
    super.oninit(vdom);

    this.loading = true;
    app.history.push(`${this.attrs.routeName}`);
    this.user = null;
    this.ignoredUsers = [];
    this.allCheck = false;
  }
  oncreate() {
    app.store.find('users', app.session.user.id()).then((results) => {
      this.user = results;
      this.ignoredUsers = this.user.ignoredUsers();
      this.loading = false;
      m.redraw();
    });
  }

  loadUser(username) {
    const lowercaseUsername = username.toLowerCase();

    // Load the preloaded user object, if any, into the global app store
    // We don't use the output of the method because it returns raw JSON
    // instead of the parsed models
    app.preloadedApiDocument();

    app.store.all('users').some((user) => {
      if ((user.username().toLowerCase() === lowercaseUsername || user.id() === username) && user.joinTime()) {
        this.show(user);
        return true;
      }

      return false;
    });

    if (!this.user) {
      app.store.find('users', username, { bySlug: true }).then(this.show.bind(this));
    }
  }

  title() {
    return <h4 className="App-titleControl person-title">{app.translator.trans('dl-blackList.forum.blackList_button')}</h4>;
  }

  view() {
    // let categories = app.store.getById('users', app.session.user.id())
    // this.ignoredUsers = categories.ignoredUsers();
    return (
      <main class="App-content">
        {this.title()}
        <div id="content">
          <div className="searchPage blackListPage">
            <div className="dl-content">
              <div>
                <div className="IndexPage-toolbar dl-discussion-container">{this.content()}</div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  content() {
    if (this.loading) {
      return (
        <div className="DiscussionList">
          <LoadingIndicator />
        </div>
      );
    }

    if (this.ignoredUsers.length === 0) {
      return (
        <div className="DiscussionList">
          <Placeholder text={app.translator.trans('dl-response.forum.warn.no_ignored')} />
        </div>
      );
    }
    return (
      <div className="ProfilePagePhoneContent">
        <div className="Header">
          <div className="Item" style="margin-right: 3vw">
            <input type="checkbox" className="Radio" checked={this.allCheck} onchange={this.onClickAll.bind(this)}></input>
            {app.translator.trans('dl-index.forum.profilePagePhone.all')}
          </div>
          <div className="Item">
            {/* <input type="checkbox" checked="true" className="Radio"></input>Remove */}
            <Button className="Button Btn" onclick={this.deleteUser.bind(this)}>
              {app.translator.trans('dl-index.forum.profilePagePhone.clear')}
            </Button>
          </div>
        </div>
        <div className="List">
          {this.ignoredUsers.map((user, i) => {
            return (
              <div className="Item">
                <a href={app.route.user(user)}>
                  <div className="Left">
                    {/* <div className="Avatar"> */}
                    {avatar(user, { className: 'Avatar' })}
                    {/* </div> */}
                    <div className="Info">
                      <div className="Name">{nickname(user)}</div>
                      <div className="Text">{signName(user)}</div>
                    </div>
                  </div>
                </a>
                <div className="Right">
                  <div className="Check">
                    <input type="checkbox" className="Radio" checked={user.checked} onchange={this.onClickSingle.bind(this, user)}></input>
                    {app.translator.trans('dl-index.forum.profilePagePhone.check')}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  deleteUser() {
    let checkUsers = [];
    for (let index = this.ignoredUsers.length - 1; index >= 0; index--) {
      const user = this.ignoredUsers[index];
      if (user.checked) {
        checkUsers.push(index);
      }
    }
    if (checkUsers.length == 0) {
      AlertUtil.onWarn(app, app.translator.trans('dl-index.forum.profilePagePhone.please_check_user'));
      return;
    }
    if (confirm(app.translator.trans(`dl-index.forum.confirm_messages.sure_ignore_label`))) {
      for (let index = checkUsers.length - 1; index >= 0; index--) {
        const user = checkUsers[index];
        this.ignoredUsers[user].save({ ignored: false });
        this.ignoredUsers.splice(user, 1);
        app.session.user.ignoredUsers = Stream(this.ignoredUsers);
      }
    }
  }
  onClickAll() {
    this.allCheck = !this.allCheck;
    this.ignoredUsers.map((item) => {
      item.checked = this.allCheck;
    });
  }
  onClickSingle(data) {
    let checked = 0;
    this.ignoredUsers.map((item) => {
      if (item.id() == data.id()) {
        item.checked = !item.checked;
      }
      if (item.checked) {
        checked++;
      }
    });
    if (checked == this.ignoredUsers.length) {
      this.allCheck = true;
    } else {
      this.allCheck = false;
    }
  }
  show(user) {
    this.user = app.session.user;

    m.redraw();
  }
}
